// GSAP Animations



$( document ).ready(function() { // doc ready for GSAP
    
gsap.registerPlugin(ScrollTrigger);
  
  // RESPONSIVE FUNCTIONS:
  ScrollTrigger.matchMedia({
	
    // desktop: bootstrap "md"
  "(min-width: 768px)": function() {
    // setup animations and ScrollTriggers for screens 800px wide or greater (desktop) here...
    // These ScrollTriggers will be reverted/killed when the media query doesn't match anymore.
    
	console.log('GSAP desktop');
	
    // ***** HOME: DESKTOP HERO SMILE ANIMATION ******   
    if ($('.js_home-hero').length){ 
      // NOTE: not the usual technique since this is applied to a top-of-the-page element:
      function smileWhiteIn(targetEl){
        //console.log("smileWhiteIn triggered ON ENTER");
        if ( !$(targetEl).hasClass('has-run') ){
            //console.log("HAS NOT RUN");
            $(targetEl).load('https://cdn.shopify.com/s/files/1/0553/5252/4989/t/19/assets/smile-animated-in_white.svg?v=5252767838325839912');
            $(targetEl).addClass('has-run');
        }
      }    
      function smileWhiteInEB(targetEl){
        $(targetEl).load('https://cdn.shopify.com/s/files/1/0553/5252/4989/t/19/assets/smile-animated-in_white.svg?v=5252767838325839912');  
        //console.log("smileWhiteIn triggered ENTER BACK");
      }    
      function smileWhiteOut(targetEl){
        $(targetEl).load('https://cdn.shopify.com/s/files/1/0553/5252/4989/t/19/assets/smile-animated-out_white.svg?v=13924691321897682407');
        //console.log("smileWhiteOut triggered ON LEAVE");
      }
      gsap.utils.toArray(".js_home-hero").forEach((container) => {
        let targetEl = container.querySelector(".js_hero-smile");
        let containerHeight = container.offsetHeight;
        ScrollTrigger.create({
          trigger: container,
          start: "top 100px",
          end: "bottom 100px",
          onEnter: () => smileWhiteIn(targetEl), // checks if this has run before
          onLeave: () => smileWhiteOut(targetEl),
          onEnterBack: () => smileWhiteInEB(targetEl),
          // no onLeaveBack!!!
          markers: false
        });
      });        
    }
   

    

    
    
  },

    // mobile: bootstrap "sm"
  "(max-width: 767px)": function() {
    // The ScrollTriggers created inside these functions are segregated and get
    // reverted/killed when the media query doesn't match anymore. 
    console.log('GSAP mobile');

    
  },
	
  // all 
  "all": function() {
    // ScrollTriggers created here aren't associated with a particular media query,
    // so they persist.

	console.log('GSAP all');

    // ***** HOME PAGE: INGREDIENT ICONS STAGGER ANIMATION ******   
    if ($('.template-index .js_pdp-icons').length){ 
      gsap.set(".js_pdp-icon-list li", {y: -50, autoAlpha: 0});
      ScrollTrigger.batch(".js_pdp-icon-list li", {
        start: "top bottom",
        onEnter: batch => gsap.to(batch, {autoAlpha: 1, y: 0, stagger: 0.15}),
        onLeave: batch => gsap.to(batch, {autoAlpha: 0, y: 50, stagger: 0.1}),
        onEnterBack: batch => gsap.to(batch, {autoAlpha: 1, y: 0, stagger: 0.15}),
        onLeaveBack:batch => gsap.to(batch, {autoAlpha: 0, y: -50, stagger: 0.1}),
        markers: false,
      });
    }
    
    
    // ***** NUTRITION PAGE: INGREDIENT ICONS STAGGER ANIMATION ******   
    if ($('.page-nutrition .js_pdp-icons').length){ 
      gsap.set(".js_pdp-icon-list li", {y: -50, autoAlpha: 0});
      ScrollTrigger.batch(".js_pdp-icon-list li", {
        start: "top 50%",
        end: "bottom top",
        onEnter: batch => gsap.to(batch, {autoAlpha: 1, y: 0, stagger: 0.15}),
        //onLeave: batch => gsap.to(batch, {autoAlpha: 0, y: 50, stagger: 0.1}),
        //onEnterBack: batch => gsap.to(batch, {autoAlpha: 1, y: 0, stagger: 0.15}),
        onLeaveBack:batch => gsap.to(batch, {autoAlpha: 0, y: -50, stagger: 0.1}),
        markers: false,
      });
    }
    
    // ***** SMILE HEADINGS ANIMATIONS ******   
    
      if ($('.js_smile_animated').length){ 
        function smileWhiteIn(targetEl){
          $(targetEl).load('https://cdn.shopify.com/s/files/1/0553/5252/4989/t/19/assets/smile-animated-in_white.svg?v=5252767838325839912');  
        }    
        function smileWhiteOut(targetEl){
          $(targetEl).load('https://cdn.shopify.com/s/files/1/0553/5252/4989/t/19/assets/smile-animated-out_white.svg?v=13924691321897682407');
        }
        function smileBerryIn(targetEl){
          $(targetEl).load('https://cdn.shopify.com/s/files/1/0553/5252/4989/t/19/assets/smile-animated-in_berry.svg?v=13149751742176762239');  
        }    
        function smileBerryOut(targetEl){
          $(targetEl).load('https://cdn.shopify.com/s/files/1/0553/5252/4989/t/19/assets/smile-animated-out_berry.svg?v=281688991161659389');
        }
        // WHITE SMILE:
        gsap.utils.toArray(".js_smile_animated.white-smile").forEach((container) => {        
          let targetEl = container.querySelector(".js_smile");
            ScrollTrigger.create({
              trigger: container,
              start: "0 bottom",
              end: "100% top",
              onEnter: () => smileWhiteIn(targetEl),
              onLeave: () => smileWhiteOut(targetEl),
              onEnterBack: () => smileWhiteIn(targetEl),
              onLeaveBack: () => smileWhiteOut(targetEl),
              markers: false
            });
         });   
        // BERRY (DEFAULT) SMILE:
        gsap.utils.toArray(".js_smile_animated:not(.white-smile)").forEach((container) => {        
          let targetEl = container.querySelector(".js_smile");
            ScrollTrigger.create({
              trigger: container,
              start: "0 bottom",
              end: "100% top",
              onEnter: () => smileBerryIn(targetEl),
              onLeave: () => smileBerryOut(targetEl),
              onEnterBack: () => smileBerryIn(targetEl),
              onLeaveBack: () => smileBerryOut(targetEl),
              markers: false
            });
         });           
        

    }
    
    

    
    

  }
	
}); 
  
  

  
}); // end GSAP doc ready wrapper

